import Image from '@/models/Image';

export default class ImageRepository {
    public static getById(imageId: string) {
        return Image.query().whereId(imageId).withAll().first();
    }
}
